import React, { useRef } from "react";
import { useEffect, useContext } from "react";
import BruttoNettoContext from "../../BruttoNettoRechnerKomponenten/BruttoNettoContext";
import extSozVsgCalcSZ from "./extSozVsgCalcSZ_korr";
import extEStCalcSZ from "./extEStCalcSZ_korr";
import { Tooltip as ReactTooltip } from "react-tooltip";

export default function ErgSz13() {
  const { bruttoNettoState, handleBruttoNettoState } =
    useContext(BruttoNettoContext);
  const bruttoGehalt = bruttoNettoState.bruttoGehalt;

  const safeHandleBruttoNettoState = useRef(handleBruttoNettoState);

  useEffect(() => {
    console.log("useEffect running");
    const abgabenBerechnen = () => {
      console.log("bruttoGehalt", bruttoGehalt);
      const grenzbetrag = 12120;
      const bmgUG = Math.min(grenzbetrag, bruttoNettoState.bruttoGehalt);
      if (bruttoGehalt > 1050) {
      }

      const { sVsgBeitrag, sVsgSatz } = extSozVsgCalcSZ(bmgUG);
      safeHandleBruttoNettoState.current("sz13SVsgSatz", sVsgSatz.toFixed(2));
      safeHandleBruttoNettoState.current(
        "sz13SVsgBeitrag",
        sVsgBeitrag.toFixed(2)
      );

      let einkommenNachAbzug;
      //für Urlaubsgeld ist keine Differenz zu SZ-Gesamtsteuer zu ermitteln
      //aber es ist die einschleifregelung von 2100 € zu beachten

      if (bruttoGehalt > 1050) {
        einkommenNachAbzug = bruttoGehalt - sVsgBeitrag;
      } else {
        einkommenNachAbzug = 0;
      }

      const steuerSZ13 = extEStCalcSZ(einkommenNachAbzug, 0);
      // offenerSaldo überflüssig wg. neuem Modell mit BMG in SZ-WG
      const offenerSaldo = Math.max(620 - einkommenNachAbzug, 0);
      console.log("offenerSaldo" + offenerSaldo);
      safeHandleBruttoNettoState.current("szEStFreiBtg", offenerSaldo);

      safeHandleBruttoNettoState.current("steuerSZ13", steuerSZ13.toFixed(2));
      safeHandleBruttoNettoState.current(
        "nettoSZ13",
        (bruttoGehalt - sVsgBeitrag - steuerSZ13).toFixed(2)
      );

      console.log(bruttoNettoState);

      //   safeHandleBruttoNettoState.current("steuer", gesamtSteuer.toFixed(2));
      //   safeHandleBruttoNettoState.current("sVsgBeitrag", sVsgBeitrag.toFixed(2));
      //   safeHandleBruttoNettoState.current("sVsgSatz", sVsgSatz.toFixed(2));
      //   safeHandleBruttoNettoState.current("nettoGehalt", nettoGehalt.toFixed(2));
    };

    abgabenBerechnen();
  }, [bruttoGehalt, safeHandleBruttoNettoState]);

  return (
    <div>
      <p className="dg_zuschläge lead">
        <b>SZ 13. Monatslohn</b>
      </p>
      <div className="result trc1">
        SV-Satz
        <span className="tooltip" data-tooltip-id="tooltip6">
          {" "}
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.sz13SVsgSatz.toLocaleString("de-DE")}%
        </span>
      </div>
      <div className="result trc2">
        SV-Beitrag:
        <span className="help_float_right">
          {bruttoNettoState.sz13SVsgBeitrag.toLocaleString("de-DE")}€
        </span>
      </div>

      <div className="result trc1">
        Steuer
        <span className="tooltip" data-tooltip-id="tooltip7">
          {" "}
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.steuerSZ13.toLocaleString("de-DE")}€
        </span>
      </div>

      <div className="result net-pay trc2">
        netto:
        <span className="help_float_right">
          {bruttoNettoState.nettoSZ13.toLocaleString("de-DE")}€
        </span>
      </div>
      <ReactTooltip id="tooltip6" place="bottom" variant="info">
        <p>Keine LAK-Umlage bei SZ.</p>
      </ReactTooltip>
      <ReactTooltip id="tooltip7" place="bottom" variant="info">
        <p>Jahressechstel (SZ 13 & 14):</p>
        <p>620€ Freibetrag</p>
        <p> 2.100€ Freigrenze </p>
        <p>günstige 6%-Besteuerung bis 25.000€</p>
      </ReactTooltip>
    </div>
  );
}
